import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Crown } from 'lucide-react';

import { useHaptics } from '@/hooks/useHaptics';
import { cn } from '@/lib/cn';

/**
 * Riot profile lookup pill — mirrors the LeaderboardCart pill shape so it
 * sits naturally in the Hub's pills row next to it.
 */
export function RiotHubTile() {
  const { t } = useTranslation('riot');
  const haptics = useHaptics();

  return (
    <Link
      to="/riot"
      onClick={() => haptics.impact('light')}
      className={cn(
        'flex h-11 items-center justify-center gap-2 rounded-lg border-2 border-brand px-6',
        'bg-bg-secondary text-xs font-bold uppercase tracking-wide text-brand',
        'transition-opacity active:opacity-80',
      )}
    >
      <Crown aria-hidden className="h-5 w-5" strokeWidth={2.5} />
      <span>{t('title.profile')}</span>
    </Link>
  );
}
